function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m9.5 24h-8c-.827 0-1.5-.673-1.5-1.5v-21c0-.827.673-1.5 1.5-1.5h8c.827 0 1.5.673 1.5 1.5v21c0 .827-.673 1.5-1.5 1.5zm-8-23c-.275 0-.5.224-.5.5v21c0 .276.225.5.5.5h8c.275 0 .5-.224.5-.5v-21c0-.276-.225-.5-.5-.5z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m22.5 24h-8c-.827 0-1.5-.673-1.5-1.5v-21c0-.827.673-1.5 1.5-1.5h8c.827 0 1.5.673 1.5 1.5v21c0 .827-.673 1.5-1.5 1.5zm-8-23c-.275 0-.5.224-.5.5v21c0 .276.225.5.5.5h8c.275 0 .5-.224.5-.5v-21c0-.276-.225-.5-.5-.5z"
}));

var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "light",
  enableBackground: "new 0 0 24 24",
  height: 24,
  viewBox: "0 0 24 24",
  width: 24
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/icon.1976ebd8.svg";
export { SvgComponent as ReactComponent };